<template>
  <div
    class="country-card card-condition condition__frequent-campaign-events"
    :class="{
      noteq: value === 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS',
      'card-condition__planLimits': hasPlanLimitsRestriction('ivtIpWithFrequentCampaignEvents'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('ivtIpWithFrequentCampaignEvents')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group
      style-type="inline"
      v-model="value"
      :label="t('Suspicious Traffic (Frequent Campaign Events)')"
    >
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IP_WITH_FREQUENT_CAMPAIGN_EVENTS" :label="t('Frequent in campaign')" />
        <ui-radio
          class="ml-16"
          value="IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS"
          :label="t('Not Frequent in campaign')"
        />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'ipWithFrequentCampaignEvents',
  defaultValue: 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS',
  planLimitsKey: 'ivtIpWithFrequentCampaignEvents',
});
</script>
